
import { PropType, defineComponent } from 'vue';

export const ALTERNATE_SEARCH_TERMS_DIRECTION = {
  ROW: 'ROW',
  COLUMN: 'COLUMN',
} as const;

const HIERARCHY = {
  PARENT: 'PARENT',
  CHILD: 'CHILD',
} as const;

type ObjectValues<T> = T[keyof T];

export type AlternateSearchTermsDirection = ObjectValues<typeof ALTERNATE_SEARCH_TERMS_DIRECTION>;

type Hierarchy = ObjectValues<typeof HIERARCHY>;

export default defineComponent({
  props: {
    alternates: {
      type: Array as PropType<Array<string>>,
      required: true,
    },
    direction: {
      type: String as PropType<AlternateSearchTermsDirection>,
      required: false,
      default: ALTERNATE_SEARCH_TERMS_DIRECTION.ROW,
    },
    /**
     * Set to true to center only the additional alternates in column mode.
     * This exists to satisfy the mobile designs. It's incredibly inflexible and should be
     * removed and reworked if it ever gets in the way.
     */
    partialCenter: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showAdditionalAlternates: false,
    };
  },
  computed: {
    firstAlternate() {
      return this.alternates[0];
    },
    additionalAlternates() {
      return this.alternates.slice(1);
    },
    containerClass() {
      if (this.direction === ALTERNATE_SEARCH_TERMS_DIRECTION.ROW) {
        return ['flex-row', 'align-items-baseline'];
      }
      return ['flex-column', 'justify-content-center', this.getCenteredClass(HIERARCHY.PARENT)];
    },
    buttonClass() {
      return {
        'btn-outline-dark': !this.showAdditionalAlternates,
        'btn-dark': this.showAdditionalAlternates,
        'my-2': this.direction === ALTERNATE_SEARCH_TERMS_DIRECTION.COLUMN,
        'mx-2': this.direction === ALTERNATE_SEARCH_TERMS_DIRECTION.ROW,
      };
    },
    xMarkClass() {
      return this.fadeInOutAdditionalAlternatesClass;
    },
    additionalAlternatesClass() {
      return [...this.fadeInOutAdditionalAlternatesClass, this.getCenteredClass(HIERARCHY.CHILD)];
    },
    fadeInOutAdditionalAlternatesClass() {
      return ['fade-in-out', { 'opacity-0': !this.showAdditionalAlternates }];
    },
  },
  methods: {
    toggleShowAdditionalAlternates() {
      this.showAdditionalAlternates = !this.showAdditionalAlternates;
    },
    getCenteredClass(hierarchy: Hierarchy) {
      if (hierarchy === HIERARCHY.PARENT) {
        return { 'align-items-center': !this.partialCenter };
      }
      return { 'align-self-center': this.partialCenter };
    },
  },
});
